var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {'controls-subscribe': true, dark: _vm.isDark}, _obj[_vm.size] = _vm.size, _obj.disabled = _vm.isDisabled, _obj.open = _vm.subscribeOpen, _obj ),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.toggleSubscribe}},[_c('IconShare'),_vm._v(" "),_c('span',{staticClass:"menu-icon"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("Subscribe")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }